import { render, staticRenderFns } from "./Archivecardview.vue?vue&type=template&id=18d7fd5a"
import script from "./Archivecardview.vue?vue&type=script&lang=js"
export * from "./Archivecardview.vue?vue&type=script&lang=js"
import style0 from "./Archivecardview.vue?vue&type=style&index=0&id=18d7fd5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports